// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./moon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./sun.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27%2373818f%27 stroke-width=%272.25%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-icon {
  width: 2rem;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.25rem;
}

@keyframes garlandFadeIn {
  0% {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes garlandAnimation1 {
  0% {
    color: #07f;
  }
  20% {
    color: #17d685;
  }
  40% {
    color: #ffd91d;
  }
  60% {
    color: #f679ff;
  }
  80% {
    color: #ab47e9;
  }
  to {
    color: #07f;
  }
}
@keyframes garlandAnimation2 {
  0% {
    color: #f679ff;
  }
  20% {
    color: #ffd91d;
  }
  40% {
    color: #ab47e9;
  }
  60% {
    color: #07f;
  }
  80% {
    color: #17d685;
  }
  to {
    color: #f679ff;
  }
}
@keyframes garlandAnimation3 {
  0% {
    color: #17d685;
  }
  20% {
    color: #07f;
  }
  40% {
    color: #ab47e9;
  }
  60% {
    color: #f679ff;
  }
  80% {
    color: #ffd91d;
  }
  to {
    color: #17d685;
  }
}
@keyframes garlandAnimation4 {
  0% {
    color: #ffd91d;
  }
  20% {
    color: #f679ff;
  }
  40% {
    color: #17d685;
  }
  60% {
    color: #07f;
  }
  80% {
    color: #ab47e9;
  }
  to {
    color: #ffd91d;
  }
}
@keyframes garlandAnimation5 {
  0% {
    color: #ab47e9;
  }
  20% {
    color: #07f;
  }
  40% {
    color: #17d685;
  }
  60% {
    color: #ffd91d;
  }
  80% {
    color: #f679ff;
  }
  to {
    color: #ab47e9;
  }
}
.garland {
  display: flex;
  position: relative;
  color: var(--black2);
}
.garland-shadow {
  will-change: transform;
  transform: translateZ(0);
  animation-duration: 12s;
  animation-iteration-count: infinite;
  animation-timing-function: steps(24, end);
}
.garland-lamp {
  will-change: transform;
  transform: translateZ(0);
  animation-duration: 12s;
  animation-iteration-count: infinite;
  animation-timing-function: steps(24, end);
}
.garland-shadow {
  color: transparent;
}
.garland-item {
  z-index: 1;
  overflow: visible;
  color: var(--black2);
}
.garland-item:nth-child(1) {
  margin-top: -5px;
  margin-left: -9px;
}
.garland-item:nth-child(1) .garland-lamp, .garland-item:nth-child(1) .garland-shadow {
  animation-name: garlandAnimation1;
}
.garland-item:nth-child(2) {
  margin-top: -3px;
  margin-left: -8px;
}
.garland-item:nth-child(2) .garland-lamp, .garland-item:nth-child(2) .garland-shadow {
  animation-name: garlandAnimation2;
}
.garland-item:nth-child(3) {
  margin-top: -8px;
  margin-left: -8px;
}
.garland-item:nth-child(3) .garland-lamp, .garland-item:nth-child(3) .garland-shadow {
  animation-name: garlandAnimation3;
}
.garland-item:nth-child(4) {
  margin-top: -6px;
  margin-left: -8px;
}
.garland-item:nth-child(4) .garland-lamp, .garland-item:nth-child(4) .garland-shadow {
  animation-name: garlandAnimation4;
}
.garland-item:nth-child(5) {
  margin-top: -7px;
  margin-left: -10px;
}
.garland-item:nth-child(5) .garland-lamp, .garland-item:nth-child(5) .garland-shadow {
  animation-name: garlandAnimation5;
}
.garland-container {
  display: flex;
  position: absolute !important;
  top: 0;
  z-index: 999;
  pointer-events: none;
  max-width: 100%;
  overflow: hidden;
  justify-content: center;
}
.garland-container.hide .garland-shadow, .garland-container.hide .garland-lamp {
  animation: none;
}

.dark .header-intercom {
  background: var(--black2);
}

.header.is-doc .user-menu-trigger {
  padding: 0.5rem 0 0.5rem 0.75rem;
}
.header.is-doc .user-menu-trigger-info span:first-child {
  color: var(--white);
}

.header-intercom {
  border-radius: 0.5rem;
  cursor: pointer;
  padding: 0.5rem 0.75rem;
  background: var(--white);
  color: var(--black9);
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid var(--black2);
  box-shadow: 0 1px 2px rgba(18, 20, 23, 0.06);
  margin-right: 0.5rem;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
}
@media (max-width: 768px) {
  .header-intercom {
    margin-right: 0;
  }
}
@media (max-width: 1124px) {
  .header-intercom-text {
    display: none;
  }
}
.header-intercom svg {
  margin-right: 0.75rem;
}
@media (max-width: 1124px) {
  .header-intercom svg {
    margin-right: 0;
  }
}
@media (max-width: 1024px) {
  .header-intercom svg {
    margin-right: 0;
  }
}
@media (max-width: 768px) {
  .header-intercom svg {
    margin-right: 0;
  }
}

.header {
  height: 56px;
  flex: 0 0 56px;
  border-bottom: 0;
  width: 100%;
  z-index: 13;
  position: relative;
  background: var(--white);
  box-shadow: 0 2px 4px -1px rgba(7, 14, 35, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
}
.header > div {
  max-width: 100%;
}
@media (max-width: 768px) {
  .header {
    border-bottom: 1px solid var(--black1);
  }
}
.header .header-logo {
  width: 240px;
  height: 100%;
  cursor: pointer;
  background: var(--white);
}
.header .header-logo.open {
  width: 70px;
}
@media (max-width: 768px) {
  .header .header-logo {
    display: flex;
    width: 70px;
  }
}
.header .header-nav {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding: 0 1rem 0 1rem;
}
.header .header-nav.open:before {
  content: "";
  height: 20px;
  width: 1px;
  background: var(--black1);
  right: calc(1rem + 3px);
  position: relative;
}
@media (max-width: 768px) {
  .header .header-nav.open:before {
    display: none;
  }
}
@media (max-width: 768px) {
  .header .header-nav {
    padding: 0;
    justify-content: flex-end;
    border-left: none !important;
    border-bottom: 0;
  }
}
.header .header-menu {
  display: flex;
  align-items: center;
  transition: all 0.15s ease;
}
.header .header-menu-icon {
  display: flex;
  position: relative;
  cursor: pointer;
  height: 100%;
  align-items: center;
  padding: 1rem 1.25rem;
  font-size: 16px;
}
@media (max-width: 768px) {
  .header .header-menu-icon {
    display: none;
  }
}
.header .header-menu-icon a {
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.header .header-menu-icon a i {
  font-size: 1.25rem;
}
.header .header-menu .color-switch {
  padding: 0 0;
  width: 44px;
  margin: 0 0.5rem 0 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 768px) {
  .header .header-menu .color-switch {
    display: none;
  }
}
.header .header-menu .color-switch .switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  margin: 0;
}
.header .header-menu .color-switch .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.header .header-menu .color-switch .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #E8E8E9;
  -webkit-transition: 0.15s;
  transition: 0.15s;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: calc(100% - 6px) 50%;
}
.header .header-menu .color-switch .slider:before {
  position: absolute;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: 50%;
  background-repeat: no-repeat;
  height: 20px;
  width: 20px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: 0.15s;
  transition: 0.15s;
  box-shadow: 0 1px 2px rgba(7, 14, 35, 0.12);
}
.header .header-menu .color-switch input:focus + .slider {
  box-shadow: 0 0 1px #E8E8E9;
}
.header .header-menu .color-switch input:checked + .slider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
  position: absolute;
  cursor: pointer;
  background-color: #E8E8E9;
  transition: 0.15s;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
}
.header .header-menu .color-switch input .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #E8E8E9;
  -webkit-transition: 0.15s;
  transition: 0.15s;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: calc(100% - 6px) 50%;
}
.header .header-menu .color-switch input .slider:before {
  position: absolute;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: 50%;
  background-repeat: no-repeat;
  height: 20px;
  width: 20px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: 0.15s;
  transition: 0.15s;
}
.header .header-menu .color-switch .slider.round {
  border-radius: 34px;
}
.header .header-menu .color-switch .slider.round:before {
  border-radius: 50%;
}
.header .header-menu .color-switch .slider.round {
  background: var(--black0);
}
.header .header-logo-image {
  width: 240px;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 0 0 1.5rem;
  justify-content: space-between;
}
.header .header-logo-image.mobile {
  display: none;
}
@media (max-width: 768px) {
  .header .header-logo-image {
    display: none;
  }
  .header .header-logo-image.mobile {
    display: flex;
    width: 77px !important;
    padding: 0;
    align-items: center;
    justify-content: center;
  }
}
.header .header-logo-image.mobile .header-logo-image-big {
  opacity: 1;
}
.header .header-logo-image.mobile .header-logo-image-small {
  display: none;
}
.header .header-logo-image.mobile.open .header-logo-image-big {
  opacity: 1;
}
.header .header-logo-image.mobile.open .header-logo-image-small {
  display: none;
}
.header .header-logo-image .header-logo-image-big {
  opacity: 1;
  transition: opacity 0.15s ease;
}
.header .header-logo-image .header-logo-image-small {
  position: absolute;
  display: none;
}
.header .header-logo-image .header-logo-suffix {
  color: var(--purple6);
  font-size: 18px;
  margin-left: 5px;
  margin-top: 5px;
  font-weight: 500;
}
.header .header-logo-image.open .header-logo-image-big {
  opacity: 0;
  transition: opacity 0.15s ease;
}
.header .header-logo-image.open .header-logo-image-small {
  display: block;
}
@media (max-width: 768px) {
  .header .header-logo-image {
    width: auto !important;
  }
}
.header .sidebar-toggler {
  display: none;
  padding: 1rem;
  font-size: 1rem;
  background-color: rgba(0, 0, 0, 0);
  border: none;
  border-radius: 0;
  outline: none;
  height: 100%;
  align-items: center;
  justify-content: center;
}
.header .sidebar-toggler span {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  font-size: 15px;
}
@media (max-width: 768px) {
  .header .sidebar-toggler {
    display: flex;
  }
}
.header button:focus {
  outline: none;
}
.header > div {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
}

.sidebar-minimized-icon {
  border-right: 1px solid var(--black1);
  padding: 0.25rem 1rem;
  cursor: pointer;
}

.onboarding-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  cursor: pointer;
}
@media (max-width: 500px) {
  .onboarding-icon {
    display: none;
  }
}

.search-icon {
  display: none;
  padding: 0.5rem;
}
@media (max-width: 768px) {
  .search-icon {
    display: flex;
  }
}

.custom-animation {
  -webkit-transform: translate3d(0, 0, 0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  will-change: transform;
  transform: translate3d(0, 0, 0);
}

.flipIn {
  -webkit-backface-visibility: visible !important;
  backface-visibility: visible !important;
  -webkit-animation-name: flipIn;
  -webkit-animation-duration: 0.35s;
  -webkit-animation-fill-mode: both;
  animation-name: flipIn;
  animation-duration: 0.35s;
  animation-fill-mode: both;
}

@keyframes flipIn {
  0% {
    -webkit-transform: perspective(600px) rotateX(50deg);
    transform: perspective(600px) rotateX(50deg);
    opacity: 0.5;
  }
  0%, 40% {
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  40% {
    -webkit-transform: perspective(600px) rotateX(0deg);
    transform: perspective(600px) rotateX(0deg);
  }
  60% {
    -webkit-transform: perspective(600px) rotateX(0deg);
    transform: perspective(600px) rotateX(0deg);
    opacity: 1;
  }
  80% {
    -webkit-transform: perspective(600px) rotateX(0deg);
    transform: perspective(600px) rotateX(0deg);
  }
  to {
    -webkit-transform: perspective(600px);
    transform: perspective(600px);
  }
}`, "",{"version":3,"sources":["webpack://./client/components/header/style.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AACF;;AAIA;EACE;IACE,UAAA;EADF;EAIA;IACE,UAAA;EAFF;AACF;AAiBA;EACE;IAAK,WAPE;EAPP;EAeA;IAAM,cAPC;EALP;EAaA;IAAM,cAPC;EAHP;EAWA;IAAM,cAPC;EADP;EASA;IAAM,cAPC;EACP;EAOA;IAAK,WAZE;EAQP;AACF;AAMA;EACE;IAAK,cAbE;EAUP;EAIA;IAAM,cAfC;EAcP;EAEA;IAAM,cAdC;EAeP;EAAA;IAAM,WAnBC;EAsBP;EAFA;IAAM,cAnBC;EAwBP;EAJA;IAAK,cAlBE;EAyBP;AACF;AALA;EACE;IAAK,cAxBE;EAgCP;EAPA;IAAM,WA1BC;EAoCP;EATA;IAAM,cAvBC;EAmCP;EAXA;IAAM,cAzBC;EAuCP;EAbA;IAAM,cA3BC;EA2CP;EAfA;IAAK,cA7BE;EA+CP;AACF;AAhBA;EACE;IAAK,cAhCE;EAmDP;EAlBA;IAAM,cAhCC;EAqDP;EApBA;IAAM,cAnCC;EA0DP;EAtBA;IAAM,WArCC;EA8DP;EAxBA;IAAM,cAlCC;EA6DP;EA1BA;IAAK,cArCE;EAkEP;AACF;AA3BA;EACE;IAAK,cAvCE;EAqEP;EA7BA;IAAM,WA5CC;EA4EP;EA/BA;IAAM,cA5CC;EA8EP;EAjCA;IAAM,cA5CC;EAgFP;EAnCA;IAAM,cA5CC;EAkFP;EArCA;IAAK,cA5CE;EAoFP;AACF;AArCA;EACE,aAAA;EACA,kBAAA;EACA,oBAAA;AAuCF;AArCE;EACE,sBAAA;EACA,wBAAA;EACA,uBAAA;EACA,mCAAA;EACA,yCAAA;AAuCJ;AApCE;EACE,sBAAA;EACA,wBAAA;EACA,uBAAA;EACA,mCAAA;EACA,yCAAA;AAsCJ;AAnCE;EACE,kBAAA;AAqCJ;AAlCE;EACE,UAAA;EACA,iBAAA;EACA,oBAAA;AAoCJ;AAlCI;EACE,gBAAA;EACA,iBAAA;AAoCN;AAlCM;EACE,iCAAA;AAoCR;AAjCI;EACE,gBAAA;EACA,iBAAA;AAmCN;AAjCM;EACE,iCAAA;AAmCR;AAhCI;EACE,gBAAA;EACA,iBAAA;AAkCN;AAhCM;EACE,iCAAA;AAkCR;AA/BI;EACE,gBAAA;EACA,iBAAA;AAiCN;AA/BM;EACE,iCAAA;AAiCR;AA9BI;EACE,gBAAA;EACA,kBAAA;AAgCN;AA9BM;EACE,iCAAA;AAgCR;AA3BE;EACE,aAAA;EACA,6BAAA;EACA,MAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AA6BJ;AA1BM;EACE,eAAA;AA4BR;;AAtBA;EACE,yBAAA;AAyBF;;AArBE;EACE,gCAAA;AAwBJ;AAtBI;EACE,mBAAA;AAwBN;;AAnBA;EACE,qBAAA;EACA,eAAA;EACA,uBAAA;EACA,wBAAA;EACA,oBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;EACA,4CAAA;EACA,oBAAA;EAEA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAqBF;AAnBE;EApBF;IAqBI,eAAA;EAsBF;AACF;AAnBI;EADF;IAEI,aAAA;EAsBJ;AACF;AAnBE;EACE,qBAAA;AAqBJ;AAnBI;EAHF;IAII,eAAA;EAsBJ;AACF;AApBI;EAPF;IAQI,eAAA;EAuBJ;AACF;AAtBI;EAVF;IAWI,eAAA;EAyBJ;AACF;;AAlBA;EACE,YAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,gDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAqBF;AAnBE;EACE,eAAA;AAqBJ;AAlBE;EAjBF;IAkBI,sCAAA;EAqBF;AACF;AAnBE;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,wBAAA;AAqBJ;AAlBI;EACE,WAAA;AAoBN;AAjBI;EAXF;IAYI,aAAA;IACA,WAAA;EAoBJ;AACF;AAjBE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;AAmBJ;AAhBM;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;AAkBR;AAhBQ;EARF;IASI,aAAA;EAmBR;AACF;AAfI;EAtBF;IAuBI,UAAA;IACA,yBAAA;IACA,4BAAA;IACA,gBAAA;EAkBJ;AACF;AAfE;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;AAiBJ;AAfI;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAiBN;AAfM;EATF;IAUI,aAAA;EAkBN;AACF;AAhBM;EACE,WAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAkBR;AAhBQ;EACE,kBAAA;AAkBV;AAZI;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAcN;AAZM;EARF;IASI,aAAA;EAeN;AACF;AAbM;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AAeR;AAZM;EACE,UAAA;EACA,QAAA;EACA,SAAA;AAcR;AAXM;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;EACA,yDAAA;EACA,4BAAA;EACA,yCAAA;AAaR;AAXQ;EACE,kBAAA;EACA,WAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,yBAAA;EACA,iBAAA;EAEA,2CAAA;AAYV;AAHQ;EACE,2BAAA;AAKV;AAFQ;EACE,mCAAA;EACA,+BAAA;EACA,2BAAA;EAEA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,yDAAA;EACA,4BAAA;AAGV;AAAQ;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;EACA,yDAAA;EACA,4BAAA;EACA,yCAAA;AAEV;AAAU;EACE,kBAAA;EACA,WAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,yBAAA;EACA,iBAAA;AAEZ;AAGM;EACE,mBAAA;AADR;AAEQ;EACE,kBAAA;AAAV;AAKM;EACE,yBAAA;AAHR;AAQE;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,8BAAA;AANJ;AAQI;EACE,aAAA;AANN;AASI;EAZF;IAaI,aAAA;EANJ;EAQI;IACE,aAAA;IACA,sBAAA;IACA,UAAA;IACA,mBAAA;IACA,uBAAA;EANN;AACF;AAcM;EACE,UAAA;AAZR;AAcM;EACE,aAAA;AAZR;AAgBQ;EACE,UAAA;AAdV;AAgBQ;EACE,aAAA;AAdV;AAmBI;EACE,UAAA;EACA,8BAAA;AAjBN;AAmBI;EACE,kBAAA;EACA,aAAA;AAjBN;AAoBI;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAlBN;AAsBM;EACE,UAAA;EACA,8BAAA;AApBR;AAsBM;EACE,cAAA;AApBR;AAwBI;EAzEF;IA0EI,sBAAA;EArBJ;AACF;AAyBC;EACG,aAAA;EACA,aAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AAvBJ;AAyBI;EACE,oEAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,4BAAA;EACA,kCAAA;EACA,0BAAA;EACA,eAAA;AAvBN;AA0BI;EAzBH;IA0BK,aAAA;EAvBJ;AACF;AA0BE;EACE,aAAA;AAxBJ;AA2BE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAzBJ;;AA6BA;EACE,qCAAA;EACA,qBAAA;EACA,eAAA;AA1BF;;AA+BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;AA5BF;AA8BE;EAPF;IAQI,aAAA;EA3BF;AACF;;AA8BA;EACE,aAAA;EACA,eAAA;AA3BF;AA4BE;EAHF;IAII,aAAA;EAzBF;AACF;;AA4BA;EACE,uCAAA;EACA,mCAAA;EACA,2BAAA;EACA,sBAAA;EACA,+BAAA;AAzBF;;AA6BA;EACE,+CAAA;EACA,uCAAA;EACA,8BAAA;EACA,iCAAA;EACA,iCAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;AA1BF;;AA6BA;EACE;IACE,oDAAA;IACA,4CAAA;IACA,YAAA;EA1BF;EA6BA;IACE,0CAAA;IACA,kCAAA;EA3BF;EA8BA;IACE,mDAAA;IACA,2CAAA;EA5BF;EA+BA;IACE,mDAAA;IACA,2CAAA;IACA,UAAA;EA7BF;EAgCA;IACE,mDAAA;IACA,2CAAA;EA9BF;EAiCA;IACE,qCAAA;IACA,6BAAA;EA/BF;AACF","sourcesContent":[".sidebar-icon {\n  width: 2rem;\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: .25rem;\n}\n\n\n\n@keyframes garlandFadeIn {\n  0% {\n    opacity: 0\n  }\n\n  to {\n    opacity: 1\n  }\n}\n\n//$color1: var(--purple6);\n//$color2: var(--black9);\n//$color3: var(--red6);\n//$color4: var(--orange6);\n//$color5: var(--cian6);\n\n$color1: #07f;\n$color2: #17d685;\n$color3: #ffd91d;\n$color4: #f679ff;\n$color5: #ab47e9;\n\n@keyframes garlandAnimation1 {\n  0% { color: $color1 }\n  20% { color: $color2 }\n  40% { color: $color3 }\n  60% { color: $color4 }\n  80% { color: $color5 }\n  to { color: $color1 }\n}\n\n@keyframes garlandAnimation2 {\n  0% { color: $color4 }\n  20% { color: $color3 }\n  40% { color: $color5 }\n  60% { color: $color1 }\n  80% { color: $color2 }\n  to { color: $color4 }\n}\n\n@keyframes garlandAnimation3 {\n  0% { color: $color2 }\n  20% { color: $color1 }\n  40% { color: $color5 }\n  60% { color: $color4 }\n  80% { color: $color3 }\n  to { color: $color2 }\n}\n\n@keyframes garlandAnimation4 {\n  0% { color: $color3 }\n  20% { color: $color4 }\n  40% { color: $color2 }\n  60% { color: $color1 }\n  80% { color: $color5 }\n  to { color: $color3 }\n}\n\n@keyframes garlandAnimation5 {\n  0% { color: $color5 }\n  20% { color: $color1 }\n  40% { color: $color2 }\n  60% { color: $color3 }\n  80% { color: $color4 }\n  to { color: $color5 }\n}\n\n\n.garland {\n  display: flex;\n  position: relative;\n  color: var(--black2);\n\n  &-shadow {\n    will-change: transform;\n    transform: translateZ(0);\n    animation-duration: 12s;\n    animation-iteration-count: infinite;\n    animation-timing-function: steps(24,end)\n  }\n\n  &-lamp {\n    will-change: transform;\n    transform: translateZ(0);\n    animation-duration: 12s;\n    animation-iteration-count: infinite;\n    animation-timing-function: steps(24,end)\n  }\n\n  &-shadow {\n    color: transparent;\n  }\n\n  &-item {\n    z-index: 1;\n    overflow: visible;\n    color: var(--black2);\n\n    &:nth-child(1) {\n      margin-top: -5px;\n      margin-left: -9px;\n\n      .garland-lamp, .garland-shadow {\n        animation-name: garlandAnimation1;\n      }\n    }\n    &:nth-child(2) {\n      margin-top: -3px;\n      margin-left: -8px;\n\n      .garland-lamp, .garland-shadow {\n        animation-name: garlandAnimation2;\n      }\n    }\n    &:nth-child(3) {\n      margin-top: -8px;\n      margin-left: -8px;\n\n      .garland-lamp, .garland-shadow {\n        animation-name: garlandAnimation3;\n      }\n    }\n    &:nth-child(4) {\n      margin-top: -6px;\n      margin-left: -8px;\n\n      .garland-lamp, .garland-shadow {\n        animation-name: garlandAnimation4;\n      }\n    }\n    &:nth-child(5) {\n      margin-top: -7px;\n      margin-left: -10px;\n\n      .garland-lamp, .garland-shadow {\n        animation-name: garlandAnimation5;\n      }\n    }\n  }\n\n  &-container {\n    display: flex;\n    position: absolute !important;\n    top: 0;\n    z-index: 999;\n    pointer-events: none;\n    max-width: 100%;\n    overflow: hidden;\n    justify-content: center;\n\n    &.hide {\n      .garland-shadow, .garland-lamp {\n        animation: none;\n      }\n    }\n  }\n}\n\n.dark .header-intercom {\n  background: var(--black2);\n}\n\n.header.is-doc {\n  .user-menu-trigger {\n    padding: .5rem 0 .5rem .75rem;\n\n    &-info span:first-child {\n      color: var(--white);\n    }\n  }\n}\n\n.header-intercom {\n  border-radius: .5rem;\n  cursor: pointer;\n  padding: .5rem .75rem;\n  background: var(--white);\n  color: var(--black9);\n  user-select: none;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid var(--black2);\n  box-shadow: 0 1px 2px rgba(18, 20, 23, 0.06);\n  margin-right: .5rem;\n\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 16px;\n\n  @media (max-width: 768px) {\n    margin-right: 0;\n  }\n\n  &-text {\n    @media (max-width: 1124px) {\n      display: none;\n    }\n  }\n\n  svg {\n    margin-right: .75rem;\n\n    @media (max-width: 1124px) {\n      margin-right: 0;\n    }\n\n    @media (max-width: 1024px) {\n      margin-right: 0;\n    }\n    @media (max-width: 768px) {\n      margin-right: 0;\n    }\n  }\n}\n\n\n\n\n.header {\n  height: 56px;\n  flex: 0 0 56px;\n  border-bottom: 0;\n  width: 100%;\n  z-index: 13;\n  position: relative;\n  background: var(--white);\n  box-shadow: 0 2px 4px -1px rgba(7, 14, 35, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > div {\n    max-width: 100%;\n  }\n\n  @media (max-width: 768px) {\n    border-bottom: 1px solid var(--black1);\n  }\n\n  .header-logo {\n    width: 240px;\n    height: 100%;\n    cursor: pointer;\n    background: var(--white);\n    //border-right: 1px solid var(--gridLine);\n\n    &.open {\n      width: 70px;\n    }\n\n    @media (max-width: 768px) {\n      display: flex;\n      width: 70px;\n    }\n  }\n\n  .header-nav {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    width: 100%;\n    padding: 0 1rem 0 1rem;\n\n    &.open {\n      &:before {\n        content: \"\";\n        height: 20px;\n        width: 1px;\n        background: var(--black1);\n        right: calc(1rem + 3px);\n        position: relative;\n\n        @media (max-width: 768px) {\n          display: none;\n        }\n      }\n    }\n\n    @media (max-width: 768px) {\n      padding: 0;\n      justify-content: flex-end;\n      border-left: none !important;\n      border-bottom: 0;\n    }\n  }\n\n  .header-menu {\n    display: flex;\n    align-items: center;\n    transition: all .15s ease;\n\n    &-icon {\n      display: flex;\n      position: relative;\n      cursor: pointer;\n      height: 100%;\n      align-items: center;\n      padding: 1rem 1.25rem;\n      font-size: 16px;\n\n      @media (max-width: 768px) {\n        display: none;\n      }\n\n      a {\n        width: 100%;\n        margin: 0 auto;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        i {\n          font-size: 1.25rem;\n        }\n      }\n    }\n\n\n    .color-switch {\n      padding: 0 0;\n      width: 44px;\n      margin: 0 .5rem 0 .5rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      @media (max-width: 768px) {\n        display: none;\n      }\n\n      .switch {\n        position: relative;\n        display: inline-block;\n        width: 44px;\n        height: 24px;\n        margin: 0;\n      };\n\n      .switch input {\n        opacity: 0;\n        width: 0;\n        height: 0;\n      };\n\n      .slider {\n        position: absolute;\n        cursor: pointer;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-color: #E8E8E9;\n        -webkit-transition: .15s;\n        transition: .15s;\n        background-image: url(\"./moon.svg\");\n        background-repeat: no-repeat;\n        background-position: calc(100% - 6px) 50%;\n\n        &:before {\n          position: absolute;\n          content: \"\";\n          background-image: url(\"./sun.svg\");\n          background-position: 50%;\n          background-repeat: no-repeat;\n          height: 20px;\n          width: 20px;\n          left: 2px;\n          bottom: 2px;\n          background-color: white;\n          -webkit-transition: .15s;\n          transition: .15s;\n\n          box-shadow: 0 1px 2px rgba(7, 14, 35, 0.12);\n        }\n      };\n\n      input {\n        &:checked + .slider {\n          //background-color: #E8E8E9;\n        }\n\n        &:focus + .slider {\n          box-shadow: 0 0 1px #E8E8E9;\n        }\n\n        &:checked + .slider:before {\n          -webkit-transform: translateX(20px);\n          -ms-transform: translateX(20px);\n          transform: translateX(20px);\n\n          position: absolute;\n          cursor: pointer;\n          background-color: #E8E8E9;\n          transition: .15s;\n          background-image: url(\"./moon.svg\");\n          background-repeat: no-repeat;\n        }\n\n        .slider {\n          position: absolute;\n          cursor: pointer;\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n          background-color: #E8E8E9;\n          -webkit-transition: .15s;\n          transition: .15s;\n          background-image: url(\"./moon.svg\");\n          background-repeat: no-repeat;\n          background-position: calc(100% - 6px) 50%;\n\n          &:before {\n            position: absolute;\n            content: \"\";\n            background-image: url(\"./sun.svg\");\n            background-position: 50%;\n            background-repeat: no-repeat;\n            height: 20px;\n            width: 20px;\n            left: 2px;\n            bottom: 2px;\n            background-color: white;\n            -webkit-transition: .15s;\n            transition: .15s;\n          }\n        }\n      };\n\n      .slider.round {\n        border-radius: 34px;\n        &:before {\n          border-radius: 50%;\n        }\n      };\n\n\n      .slider.round {\n        background: var(--black0);\n      }\n    }\n  }\n\n  .header-logo-image {\n    width: 240px;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    padding: 0 0 0 1.5rem;\n    justify-content: space-between;\n\n    &.mobile {\n      display: none;\n    }\n\n    @media (max-width: 768px) {\n      display: none;\n\n      &.mobile {\n        display: flex;\n        width: 77px !important;\n        padding: 0;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n\n    .header-logo-image-big, .header-logo-image-small {\n      //margin-left: 7px;\n    }\n\n    &.mobile {\n      .header-logo-image-big {\n        opacity: 1;\n      }\n      .header-logo-image-small {\n        display: none;\n      }\n\n      &.open {\n        .header-logo-image-big {\n          opacity: 1;\n        }\n        .header-logo-image-small {\n          display: none;\n        }\n      }\n    }\n\n    .header-logo-image-big {\n      opacity: 1;\n      transition: opacity .15s ease;\n    }\n    .header-logo-image-small {\n      position: absolute;\n      display: none;\n    }\n\n    .header-logo-suffix {\n      color: var(--purple6);\n      font-size: 18px;\n      margin-left: 5px;\n      margin-top: 5px;\n      font-weight: 500;\n    }\n\n    &.open {\n      .header-logo-image-big {\n        opacity: 0;\n        transition: opacity .15s ease;\n      }\n      .header-logo-image-small {\n        display: block;\n      }\n    }\n\n    @media (max-width: 768px) {\n      width: auto !important;\n    }\n  }\n\n\n .sidebar-toggler {\n    display: none;\n    padding: 1rem;\n    font-size: 1rem;\n    background-color: #0000;\n    border: none;\n    border-radius: 0;\n    outline: none;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n\n    & span {\n      background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='%2373818f' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\") !important;\n      display: inline-block;\n      width: 1.5em;\n      height: 1.5em;\n      vertical-align: middle;\n      content: \"\";\n      background-repeat: no-repeat;\n      background-position:  center center;\n      background-size: 100% 100%;\n      font-size: 15px;\n    }\n\n    @media (max-width: 768px) {\n      display: flex;\n    }\n  }\n\n  button:focus {\n    outline: none;\n  }\n\n  & > div {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    position: relative;\n  }\n}\n\n.sidebar-minimized-icon {\n  border-right: 1px solid var(--black1);\n  padding: 0.25rem 1rem;\n  cursor: pointer;\n};\n\n\n\n.onboarding-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: .5rem;\n  cursor: pointer;\n\n  @media (max-width: 500px) {\n    display: none;\n  }\n}\n\n.search-icon {\n  display: none;\n  padding: .5rem;\n  @media (max-width: 768px) {\n    display: flex;\n  }\n}\n\n.custom-animation {\n  -webkit-transform: translate3d(0, 0, 0);\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  will-change: transform;\n  transform: translate3d(0, 0, 0);\n}\n\n\n.flipIn {\n  -webkit-backface-visibility: visible!important;\n  backface-visibility: visible!important;\n  -webkit-animation-name: flipIn;\n  -webkit-animation-duration: .35s;\n  -webkit-animation-fill-mode: both;\n  animation-name: flipIn;\n  animation-duration: .35s;\n  animation-fill-mode: both;\n}\n\n@keyframes flipIn {\n  0% {\n    -webkit-transform: perspective(600px) rotateX(50deg);\n    transform: perspective(600px) rotateX(50deg);\n    opacity: .5;\n  }\n\n  0%,40% {\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in\n  }\n\n  40% {\n    -webkit-transform: perspective(600px) rotateX(0deg);\n    transform: perspective(600px) rotateX(0deg);\n  }\n\n  60% {\n    -webkit-transform: perspective(600px) rotateX(0deg);\n    transform: perspective(600px) rotateX(0deg);\n    opacity: 1;\n  }\n\n  80% {\n    -webkit-transform: perspective(600px) rotateX(0deg);\n    transform: perspective(600px) rotateX(0deg)\n  }\n\n  to {\n    -webkit-transform: perspective(600px);\n    transform: perspective(600px)\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
